import { render, staticRenderFns } from "./UpdateCustomer.vue?vue&type=template&id=0920db30&scoped=true&"
import script from "./UpdateCustomer.vue?vue&type=script&lang=js&"
export * from "./UpdateCustomer.vue?vue&type=script&lang=js&"
import style0 from "./UpdateCustomer.vue?vue&type=style&index=0&id=0920db30&prod&scoped=true&lang=css&"
import style1 from "./UpdateCustomer.vue?vue&type=style&index=1&id=0920db30&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0920db30",
  null
  
)

export default component.exports